module.exports = __webpack_public_path__ + "img/TransUnion-Logo.27898418.svg";